import { create, test, enforce } from 'vest';

const validators = create((data = {}) => {
  test(
    'verification',
    'Token cannot be shorter than 6 characters and longer than 20 characters.',
    () => {
      enforce(data.verification).longerThanOrEquals(6).shorterThanOrEquals(20);
    }
  );
});

export default validators;
